var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyesTiredEyes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-tiredeyes,.cls-4-tiredeyes,.cls-5-tiredeyes{fill:none;}.cls-2-tiredeyes{fill:#a64daa;}.cls-3-tiredeyes{clip-path:url(#clip-path);}.cls-4-tiredeyes,.cls-5-tiredeyes{stroke:#a64daa;stroke-linecap:round;stroke-linejoin:round;}.cls-4-tiredeyes{stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-tiredeyes",
    x: 6.15,
    y: 24.83,
    width: 90.79,
    height: 66.61
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-tiredeyes",
    d: "M11.94,51.46a1.9,1.9,0,0,1-.61-.1,2.11,2.11,0,0,1-1.41-1.82C7.47,36.92,15.84,30.15,21.17,28.15c25.14-9.46,48.39-.73,65.36,5.65l1.69.64a1.5,1.5,0,0,1-.9,2.85C40.4,25.14,22.42,42.41,15.65,48.92,14,50.53,13,51.46,11.94,51.46ZM44.3,27A62.06,62.06,0,0,0,22.23,31a15.21,15.21,0,0,0-9.59,16.69c.3-.28.63-.59.93-.89A53.48,53.48,0,0,1,35.29,33.38c9.52-3.11,20.54-4,32.93-2.69A87,87,0,0,0,44.3,27Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3-tiredeyes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-tiredeyes",
    d: "M86.59,68a11.65,11.65,0,0,0-14.29.71,27.92,27.92,0,0,1-11.63,6.61,29.14,29.14,0,0,1-9.35.9c-3.11-.14-4.45-.54-12.45-2.42-2.95-.69-5.42-1.28-7.22-1.72,0,0-12.15,1.2-14.5,1.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-tiredeyes",
    d: "M63,74.86c1.45.24,7,1.3,8.77,5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-tiredeyes",
    d: "M21,64.28c-3.3,2.78-6.13,4.82-8,6.11q3.78-.92,7.46-2.19C26.82,66,37.94,55.33,44,54.42A27.44,27.44,0,0,1,57.35,56.1c15.88,6.33,18.63,6.25,22.4,6.68A15.57,15.57,0,0,0,89.07,61c.05,0,4.86-3.75,6.22-5.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-tiredeyes",
    d: "M34.07,51.08c1.54-.77,2.7-1.17,8.67-6.29,1.76-1.5,5.8-4.4,7.34-4.73l-.3.18C53,40,55.61,42.68,59.64,45c13.71,7.72,16.16,7.85,19.5,8.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-tiredeyes",
    d: "M70.8,70.55s5.6-1.31,9.66,4.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-tiredeyes",
    d: "M67.16,61.43a12.14,12.14,0,1,1-21.54-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-tiredeyes",
    d: "M75.63,61.61s9.17-.55,10.6-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-tiredeyes",
    d: "M58.58,64.76a4.92,4.92,0,1,1-4.91-4.91h0a4.91,4.91,0,0,1,4.91,4.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-tiredeyes",
    d: "M28.32,67.52a5,5,0,0,1,3.23-1.13A4.17,4.17,0,0,0,34,66.13a4.1,4.1,0,0,0,.85-1,4.72,4.72,0,0,1,1.82-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-tiredeyes",
    d: "M31.22,66.3c1.6.15,2.13,2.59,3.7,2.89a3.22,3.22,0,0,0,1.82-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-tiredeyes",
    d: "M29.86,71.72c2.83,5.2,8.58,8,14.17,10a88.82,88.82,0,0,0,21.36,4.66"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesTiredEyes);
export default __webpack_public_path__ + "static/media/eyes-tired-eyes.329a68b4.svg";
export { ForwardRef as ReactComponent };